import { render, staticRenderFns } from "./MoveToFixedSequencesApproval.vue?vue&type=template&id=0621fc9c&scoped=true"
import script from "./MoveToFixedSequencesApproval.vue?vue&type=script&lang=js"
export * from "./MoveToFixedSequencesApproval.vue?vue&type=script&lang=js"
import style0 from "./MoveToFixedSequencesApproval.vue?vue&type=style&index=0&id=0621fc9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0621fc9c",
  null
  
)

export default component.exports